module.exports = __webpack_public_path__ + "img/26.4fcd7c69.jpg";